import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface StateType {
  direction: string;
  theme: string;
  themePrimary: string,            
};
@Injectable({
  providedIn: 'root'
})
export class LandingStateService {
  private readonly localStorageKey = 'mamix-ng'; // Customize this key
  private initialState: StateType = {
    theme: 'light',           
    direction: 'ltr',               
    themePrimary: '',              
  } 
  // Store initial state
  private stateSubject = new BehaviorSubject<StateType>(this.initialState); // Use any for initial null value
  state$ = this.stateSubject.asObservable();

  constructor() {
    const initialState: StateType = this.getInitialStateFromLocalStorage();
    this.initializeState();
    this.stateSubject.next(initialState);
  }

  private getInitialStateFromLocalStorage(): StateType {
    try {
      const storedState = localStorage.getItem(this.localStorageKey);
      if (storedState) {
        return JSON.parse(storedState);
      }
    } catch (error) {
      console.error('Error retrieving initial state from local storage:', error);
    }
    return this.initialState;
  }

  private initializeState() {
    const state = { ...this.initialState }; // Clone initial state to avoid mutation
    this.applyDirectionSpecificChanges(state.direction); // Apply initial changes
    this.stateSubject.next(state); // Emit initial state after changes
  }

  updateState(newState?: Partial<any>) { // Use any for partial updates
    const currentState = this.stateSubject.getValue(); // Get current state

    
    
    if (!currentState) {
      // Handle initial update case (no state emitted yet)
      this.updateStateAndEmit(newState);
      return;
    }
    if (newState) {
      const updatedState = { ...currentState, ...newState }; // Merge updates
      this.updateStateAndEmit(updatedState); // Update and emit combined state
    } else {
      this.updateStateAndEmit(currentState);
      return;
    }
    localStorage.removeItem('hs_theme')
  }
  private applyDirectionSpecificChanges(direction: string) {
    let html = document.querySelector('html');
    html?.setAttribute('dir', direction);
  } 

  private applythemeSpecificChanges(theme: string) {
    let html = document.querySelector('html');
    html?.setAttribute('class', theme);  //setting theme style
  }

  private applyLandingPrimarySpecificChanges(primary: any) {
    let html = document.querySelector('html');        
    html?.style.setProperty('--primary-rgb', primary);
    html?.style.setProperty('--primary', primary.primary1);
  }
  private applyLandingPrimarySpecificChanges1(primary: any) {
    let html = document.querySelector('html');    
    html?.style.setProperty('--primary', primary.primary1);
    html?.style.setProperty('--color-primary-rgb', primary.primaryrgb);
  }
    public applyReset() {
    let html = document.querySelector('html');
    if(html){
      html?.style.removeProperty('--primary-rgb');
      html?.style.removeProperty('--primary');
      html?.style.removeProperty('--color-primary-rgb');

    }
    html?.setAttribute('data-vertical-style','menu-hover');
    this.stateSubject.next(this.initialState);
    this.updateStateAndEmit(this.initialState);
    localStorage.clear();

    const checkedElement = document.querySelector('[name="theme-primary"]:checked') as HTMLInputElement | null;
    // Check if the element exists before trying to modify it
    if (checkedElement) {
        checkedElement.checked = true;
    }
  }

  private updateStateAndEmit(state: any) {   
    // Conditional logic based on direction changes        
    const currentState = this.stateSubject.getValue(); // Get current state    
    // Conditional logic based on theme changes
    if (state['theme']) {
      this.applythemeSpecificChanges(state['theme']);
    }
    if (state['direction']) {
      this.applyDirectionSpecificChanges(state['direction']);
    }
    if (state['themePrimaryColor']) {
      this.applyLandingPrimarySpecificChanges(state['themePrimaryColor']);
    }
    if (state['themePrimaryColor1']) {
      this.applyLandingPrimarySpecificChanges1(state['themePrimaryColor1']);
    }
    this.stateSubject.next(state);
    this.updateLocalStorage(state);
  }

  private updateLocalStorage(state: any) {
    try {
      localStorage.setItem(this.localStorageKey, JSON.stringify(state));
    } catch (error) {
      console.error('Error saving state to local storage:', error);
    }
  }
}
